import React, { useState, useRef, useCallback, useEffect, useContext } from 'react';
import './TextInput.css';
import { Picker } from 'emoji-mart';
import { Dropdown, Tabs, Tab } from 'react-bootstrap';
import 'emoji-mart/css/emoji-mart.css'
import { useTranslation } from "react-i18next";
// import ContentEditable from 'react-contenteditable'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build';
import TemplateMsg from '../../UI/TemplateMsg/TemplateMsg';
import AlertContext from '../../../context/AlertModelContext/AlertModalContext';
import i18next from "i18next";

// import TemplateMsgItem from '../../UI/TemplateMsg/TemplateMsgItem';


const TextInput = (props) => {
    const { onAttachFilesWithoutGallery, selectedChannel: msgType, clientName } = props
    const alertCtx = useContext(AlertContext)
    const [isRecording, setIsRecording] = useState(false);
    const [isBlinking, setIsBlinking] = useState(false);
    const mediaRecorderRef = useRef(null);
    const streamRef = useRef(null); // Ref to store the MediaStream
    const recordedChunks = useRef([]);
    const blinkIntervalRef = useRef(null);

    const [t] = useTranslation('common')
    const appAccess = props.companyDetails?.appAccess
    const emojiPicker = <Picker showSkinTones={false} showPreview={false} emoji={''} sheetSize={16} onSelect={props.emojiSelect} set='google' />;

    const lang = i18next.language

    useEffect(() => {
        // Clean up the blinking interval when the component unmounts
        return () => {
            if (blinkIntervalRef.current) {
                clearInterval(blinkIntervalRef.current);
            }
        };
    }, []);

    useEffect(() => {
        handleStopRecording()
    }, [msgType, clientName]);


    const handleStop = (blob) => {
        setIsRecording(false); // Stop recording and reset the icon color
        setIsBlinking(false); // Stop blinking effect
        const reader = new FileReader();
        reader.onloadend = () => {
            const arrayBuffer = reader.result;
            const bytes = new Uint8Array(arrayBuffer);

            // Get current date and time for the filename
            const lastModifiedDate = new Date();
            const dateString = lastModifiedDate.toISOString().replace(/[:.]/g, '-'); // Format as "YYYY-MM-DDTHH-MM-SS"
            const extension = blob.type.split('/')[1];
            const name = `recording_${dateString}.${extension}`;
            const type = blob.type;
            const file = new File([blob], name, { type });
            onAttachFilesWithoutGallery([file]);
        };

        reader.readAsArrayBuffer(blob); // Read the Blob as an ArrayBuffer
    };


    const handleStartRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });

            mediaRecorderRef.current = mediaRecorder;
            streamRef.current = stream; // Save the stream for later cleanup
            recordedChunks.current = []; // Reset chunks

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    recordedChunks.current.push(event.data);
                }
            };

            mediaRecorder.onstop = () => {
                const blob = new Blob(recordedChunks.current, { type: 'audio/webm' });
                handleStop(blob); // Process the recorded data
            };

            mediaRecorder.start();
            setIsRecording(true);
            setIsBlinking(true); // Start blinking effect

            // Set up blinking interval
            blinkIntervalRef.current = setInterval(() => {
                setIsBlinking(prev => !prev);
            }, 500); // Blink every 500ms

        } catch (error) {
            alertCtx.showAlert(t('fail'), t('Please check microphone connection or browser permissions to use microphone on effective'), 'sm')
        }
    };

    const handleStopRecording = () => {
        if (mediaRecorderRef.current && isRecording) {
            mediaRecorderRef.current.stop(); // Ensure this line is called to stop the recording
            // Stop all tracks in the MediaStream
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
            }

            setIsRecording(false); // Reset the recording state
            setIsBlinking(false); // Stop blinking effect
            clearInterval(blinkIntervalRef.current); // Clear blinking interval
        } else {
            console.warn('MediaRecorder is not available or already stopped');
        }
    };


    const templateMessageClickHandler = (selectedTempMsg) => {
        //if its file type template
        if (['image', 'video', 'document'].includes(selectedTempMsg.templateType)) {
            props.onToggleFileManager(selectedTempMsg.templateType)
        }
        props.addedChar({ target: { value: selectedTempMsg.msg }, preventDefault: () => (null) })
    }

    const sendMsgClickHandler = (e) => {
        if (isRecording) {
            return alertCtx.showAlert(t('fail'), t('Before you can send a message please pause the recording'), 'sm')
        }
        e.preventDefault()
        props.sendClicked()
    }

    if (props.selectedChannel === 'lead') {
        return (
            <div className={`row inChatbottomRowLeft ${props.selectedChannel === 'mail' ? 'in-chat-bottom--mail' : ''}`}>
                <div className='TextChatSection'>
                    <section className='input-group section-main-textarea--readonly'>
                        <div className='read-only-text-container'>
                            <h2 className='main-textarea-h2--readonly'><span>{t('read only')}</span><i className="fa-solid fa-ban marging-left--5px read-only-icon" /></h2>
                            <p className='main-textarea-p--readonly'>{t('this channel is read-only. you cannot send text/images on this channel')}</p>
                        </div>
                    </section>
                </div>
            </div>
        )
    }

    return (
        <div className={`row inChatbottomRowLeft ${props.selectedChannel === 'mail' ? 'in-chat-bottom--mail' : ''}`}>
            <div className='TextChatSection'>

                <div className='input-group chat-text-input-area'>
                    <div className='input-group-append'>
                        {props.selectedChannel !== 'sms' && props.selectedChannel !== 'webchat' && <span className='input-group-text btn_attach' onClick={props.onToggleFileManager}><i className='fas fa-paperclip attach-icon chatIcons' /></span>}
                        {props.selectedChannel !== 'mail' && <Dropdown drop='up'>{/*drop='right'*/}
                            <Dropdown.Toggle variant='outline-secondary' className='btn_emoji'><i className="far fa-grin-alt chatIcons"></i></Dropdown.Toggle>
                            <Dropdown.Menu className="emojiCustomMenu">
                                {emojiPicker}
                            </Dropdown.Menu>
                        </Dropdown>}
                        {appAccess !== 'DIALER'
                            && <TemplateMsg filterCondition="display" drop='up' tempMsgs={props.tempMsgs} templateMessageClickHandler={templateMessageClickHandler} >
                                <Dropdown.Toggle variant='outline-secondary' className='btnTemplate'><i className="fa-regular fa-comment-dots chatIcons templateIcon" /></Dropdown.Toggle>
                            </TemplateMsg>
                        }

                        {props.selectedChannel !== 'webchat' && props.selectedChannel !== 'sms' && props.selectedChannel !== 'mail' && props.selectedChannel && (
                            <span
                                className={`input-group-text btn-recording ${isBlinking ? 'blinking-color' : ''}`}
                                onClick={!isRecording ? handleStartRecording : handleStopRecording}
                            >
                                {!isRecording ? (
                                    <i className='fa-solid fa-microphone-lines microphon-icon chatIcons' />
                                ) : (
                                    <i className='fa-solid fa-microphone-lines-slash microphon-icon chatIcons' />
                                )}
                            </span>
                        )
                        }
                    </div>


                    {/* {props.selectedChannel === 'mail' ? 
                    <span title='השב להודעה האחרונה' onClick={props.handleMailReplyClicked} className={props.mailReplyClicked ? 'input-group-text btn_mail_reply mailReplyClicked' : 'input-group-text btn_mail_reply'}><i title='השב להודעה האחרונה' className="fas fa-reply chatIcons" /></span> : null} */}
                    {props.selectedChannel === 'mail' ? <div className='form-control mailDic'>
                        <textarea id="mainTextArea" name='' className={`form-control mailSubjectBox ${lang === 'en' && 'ltr'}`} onKeyDown={(e) => props.onKeyBoardClick(e, 'mainTextInput')} value={props.mailSubject} onChange={props.handleOnMailSubjectChanged} placeholder={t('Subject')} />
                        {/* <textarea id="mainTextArea" name='' className='form-control mailMsgBox' onKeyDown={(e) => props.onKeyBoardClick(e, 'mainTextInput')} onChange={props.addedChar} value={props.value} placeholder='הקלד את הודעתך כאן' /> */}
                        <CKEditor
                            editor={ClassicEditor}
                            config={
                                {
                                    placeholder: `${t('Type your message here')}. (${t('For emoji press (Windows key) + .')})`,
                                    language: {
                                        ui: lang ,
                                        content: lang,  // or 'he' for Hebrew if you want RTL
                                    }
                                }
                            }
                            data={props.value}
                            // onReady={editor => {
                            //     // You can store the "editor" and use when it is needed.
                            //     console.log('Editor is ready to use!', editor);
                            // }}
                            disabled={isRecording}
                            value={props.value}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                // console.log(data)
                                props.addedChar({ target: { value: data } })
                            }}
                        // onBlur={(event, editor) => {
                        //     console.log('Blur.', editor);
                        // }}
                        // onFocus={(event, editor) => {
                        //     console.log('Focus.', editor);
                        // }}
                        />

                    </div>
                        :

                        <textarea disabled={isRecording} id="mainTextArea" name='' className={`form-control msgBox ${lang === 'en' && 'ltr'}`} onKeyDown={(e) => props.onKeyBoardClick(e, 'mainTextInput')} onChange={props.addedChar} value={!isRecording ? props.value : t('Voice recording is active, please cancel the recording to continiu writing')} placeholder={t('Type your message here')} />


                        // <ContentEditable className='form-control msgBox' onKeyDown={(e) => props.onKeyBoardClick(e, 'mainTextInput')} onChange={props.addedChar} html={props.msgTextBoxDisplay} />
                        // <div className='form-control react-input-emoji--container2'>
                        // {/* <div className={isPlaceHolderVisibale} >הקלד את הודעתך כאן</div> */}
                        // <div tabindex="0" contenteditable="true" className="react-input-emoji--input2" suppressContentEditableWarning={true} onKeyDown={(e) => props.onKeyBoardClick(e, 'mainTextInput')} onInput={props.addedChar} >{props.msgTextBoxDisplay}</div>
                        // </div>

                    }




                    {props.selectedChannel === 'mail' ?
                        <Dropdown drop='up' >{/*drop='right'*/}
                            <Dropdown.Toggle variant='outline-secondary' className='btn_emoji'><i className="fas fa-ellipsis-h chatIcons"></i></Dropdown.Toggle>
                            <Dropdown.Menu className="mailSettingsCustomMenu">
                                <div className='mailSettingsDropDownItem'><p className='mailSettingsText'>To:</p><input value={props.mailTo} onChange={(e) => props.handleOnMailToChanged(e, 'try')} type='text' className='mailSettingsInput' /></div>
                                <div className='mailSettingsDropDownItem'><p className='mailSettingsText'>Cc:</p><input value={props.mailCc} onChange={props.handleOnMailCcChanged} type='text' className='mailSettingsInput' /></div>
                                <div className='mailSettingsDropDownItem'><p className='mailSettingsText'>Bcc:</p><input value={props.mailBcc} onChange={props.handleOnMailBccChanged} type='text' className='mailSettingsInput' /></div>
                            </Dropdown.Menu>
                        </Dropdown>
                        // <span title='הגדרות מתקדמות' className='input-group-text btn_mail_reply'><i title='הגדרות מתקדמות' className="fas fa-ellipsis-h" /></span>
                        : null}

                    <div className='input-group-append'>

                        <button className='input-group-text btn_send' onClick={sendMsgClickHandler}><i className='fa-regular fa-paper-plane fa-lg' /><span className='sendBtnTitle'>{t('Send')}</span></button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TextInput;

